/* ============================================================
   CoCafe Host Portal — dummy data
   Host: Meera Krishnan · Loftworks Coffee (Chennai)
   Built to feel like a real, mid-size host's account.
   ============================================================ */

const IMG = (id, w = 800) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=70`;

  const host = {
    name: "Athik Ahamed",
    initials: "AA",
    email: "athik.ahamed@cocafe.hosts",
    phone: "+91 96500 12345",
    joined: "January 2024",
    role: "Owner",
    superhost: true,
    payoutNext: "Mon, 16 Jun",
    payoutAmount: 28650,
    payoutMethod: "HDFC •••• 8921",
  };

  const locations = [
    {
      id: "nungambakkam",
      name: "Loftworks Coffee",
      area: "Nungambakkam",
      city: "Chennai",
      address: "14, Khader Nawaz Khan Road, Nungambakkam, Chennai 600006",
      thumb: IMG("1521017432531-fbd92d768814", 120),
      status: "live",
      seats: 10,
      rating: 4.9,
      reviews: 287,
    },
    {
      id: "kadayar",
      name: "CoCafe Kadayar",
      area: "Kadayar",
      city: "Chennai",
      address: "45, T.P. Kumaran Street, Kadayar, Chennai 600023",
      thumb: IMG("1494521869914-b8fe553183d1", 120),
      status: "live",
      seats: 12,
      rating: 4.8,
      reviews: 156,
    },
  ];

  // ---- today's bookings (operational view) ----
  const today = [
    { id: "CC-7F3K2", guest: "Aarav Menon", initials: "AM", c: 0, start: 9, end: 13, dur: "4h", seats: 1, amount: 499, status: "checked-in", note: "Prefers the window desk by the plug bank.", repeat: true, rating: null },
    { id: "CC-5G2LP", guest: "Sneha Reddy", initials: "SR", c: 1, start: 10, end: 11, dur: "1h", seats: 1, amount: 149, status: "checked-in", note: "Booked the phone booth add-on for a 10:30 call.", repeat: false, rating: null },
    { id: "CC-8K9WZ", guest: "Team Northstar", initials: "TN", c: 2, start: 14, end: 17, dur: "3h", seats: 4, amount: 399, status: "upcoming", note: "Group of 4 — asked to sit together. Meeting room held.", repeat: true, rating: null },
    { id: "CC-3J6PL", guest: "Karthik Varma", initials: "KV", c: 3, start: 15, end: 19, dur: "4h", seats: 2, amount: 499, status: "upcoming", note: "", repeat: false, rating: null },
    { id: "CC-2H9QD", guest: "Divya Nair", initials: "DN", c: 4, start: 18, end: 21, dur: "3h", seats: 1, amount: 399, status: "upcoming", note: "First booking — flag for a warm welcome.", repeat: false, rating: null },
  ];

  // ---- full bookings ledger ----
  function mk(id, guest, c, dateLabel, dayOffset, start, dur, hours, seats, amount, status, channel, note, requests) {
    return { id, guest, initials: guest.split(" ").map((s) => s[0]).slice(0, 2).join(""), c, dateLabel, dayOffset, start, end: start + hours, dur, seats, amount, status, channel, note: note || "", requests: requests || [] };
  }
  const bookings = [
    mk("CC-7F3K2", "Aarav Menon", 0, "Today", 0, 9, "4h", 4, 1, 499, "checked-in", "app", "Regular — 11th visit this quarter.", ["Window seat"]),
    mk("CC-5G2LP", "Sneha Reddy", 1, "Today", 0, 10, "1h", 1, 1, 149, "checked-in", "app", "", ["Phone booth"]),
    mk("CC-8K9WZ", "Team Northstar", 2, "Today", 0, 14, "3h", 3, 4, 399, "upcoming", "app", "Recurring Thursday team block.", ["Sit together", "Meeting room"]),
    mk("CC-3J6PL", "Karthik Varma", 3, "Today", 0, 15, "4h", 4, 2, 499, "upcoming", "web", "", []),
    mk("CC-2H9QD", "Divya Nair", 4, "Today", 0, 18, "3h", 3, 1, 399, "upcoming", "web", "First-time guest.", ["Quiet corner"]),
    mk("CC-9M1RT", "Rohan Pillai", 5, "Tomorrow", 1, 8, "6h", 6, 1, 699, "upcoming", "app", "", []),
    mk("CC-4N7BX", "Anjali Iyer", 0, "Tomorrow", 1, 11, "4h", 4, 1, 499, "upcoming", "app", "", ["Standing desk"]),
    mk("CC-6P2WK", "Vikram Shah", 1, "Tomorrow", 1, 13, "3h", 3, 2, 399, "upcoming", "web", "", []),
    mk("CC-1Q8VD", "Maya D'Souza", 2, "Sat, 14 Jun", 2, 9, "Day pass", 10, 1, 899, "app", "Writer — usually stays the full day.", ["Reading nook"]),
    mk("CC-3R5ZN", "Imran Q.", 3, "Sat, 14 Jun", 2, 16, "1h", 1, 1, 149, "upcoming", "web", "", []),
    mk("CC-8T4LM", "Priya Raman", 4, "Sun, 15 Jun", 3, 10, "4h", 4, 3, 499, "app", "", ["Meeting room"]),
    // history
    mk("CC-4M0BR", "Aarav Menon", 0, "Mon, 2 Jun", -7, 14, "3h", 3, 1, 399, "completed", "app", "", []),
    mk("CC-2T8HD", "Naveen K.", 1, "Mon, 2 Jun", -7, 9, "4h", 4, 1, 499, "completed", "web", "", []),
    mk("CC-7W3FQ", "Sneha Reddy", 1, "Sun, 1 Jun", -8, 11, "1h", 1, 1, 149, "completed", "app", "", []),
    mk("CC-5Y9KP", "Lakshmi V.", 5, "Sat, 31 May", -9, 13, "6h", 6, 2, 699, "completed", "app", "", []),
    mk("CC-9Z2BN", "Arjun M.", 3, "Fri, 30 May", -10, 8, "4h", 4, 1, 499, "completed", "web", "", []),
    mk("CC-6A1CD", "Fatima S.", 4, "Thu, 29 May", -11, 15, "3h", 3, 1, 399, "no-show", "web", "Did not check in. Charged 50% no-show fee per policy.", []),
    mk("CC-3B7EF", "Team Quill", 2, "Wed, 28 May", -12, 10, "4h", 4, 5, 499, "cancelled", "app", "Guest cancelled 3h before — within free window, full refund.", []),
    mk("CC-8C4GH", "Deepak R.", 0, "Wed, 28 May", -12, 9, "Day pass", 10, 1, 899, "completed", "app", "", []),
  ];

  // ---- pending actions that need the host ----
  const actions = [
    { id: "a1", kind: "cancellation", title: "Cancellation request — CC-9M1RT", who: "Rohan Pillai", detail: "Requested 22h before start. Within free-cancellation window — full refund of ₹699 applies per policy.", amount: 699, time: "18 min ago" },
    { id: "a2", kind: "review", title: "New 3★ review needs a response", who: "Fatima S.", detail: "\u201cGood coffee but the wifi dropped twice during my call.\u201d Responding within 24h improves your reply rate.", time: "2h ago" },
    { id: "a3", kind: "modify", title: "Reschedule request — CC-6P2WK", who: "Vikram Shah", detail: "Wants to move Fri 1pm \u2192 Fri 4pm. The 4pm slot is open.", time: "4h ago" },
  ];

  // ---- notifications ----
  const notifications = [
    { id: "n1", icon: "calendar", title: "New booking confirmed", body: "Priya Singh booked 4h for team meeting on 14 Jun, 2:00–6:00pm.", time: "24m", unread: true, tone: "green" },
    { id: "n2", icon: "alert", title: "Cancellation request", body: "Rohan Pillai requested to cancel CC-9M1RT (within free window).", time: "15m", unread: true, tone: "amber" },
    { id: "n3", icon: "star", title: "New 5★ review", body: "Priya Singh left a 5★ review — great feedback for your space!", time: "8m", unread: true, tone: "clay" },
    { id: "n4", icon: "trending", title: "Weekly revenue milestone", body: "You've earned ₹28,650 this week — up 15% from last week! 📈", time: "2h", unread: false, tone: "green" },
    { id: "n5", icon: "users", title: "New repeat guest", body: "Aarav Menon just booked his 12th session this quarter!", time: "3h", unread: false, tone: "blue" },
    { id: "n6", icon: "wifi", title: "WiFi performance excellent", body: "Speed test: 250 Mbps down, 95 Mbps up — verified badge maintained!", time: "1d", unread: false, tone: "green" },
  ];

  // ---- weekly performance (this week) ----
  const week = [
    { d: "Mon", rev: 3850, occ: 78, bookings: 12 },
    { d: "Tue", rev: 4220, occ: 85, bookings: 14 },
    { d: "Wed", rev: 5100, occ: 92, bookings: 16 },
    { d: "Thu", rev: 4680, occ: 88, bookings: 15 },
    { d: "Fri", rev: 6150, occ: 96, bookings: 18 },
    { d: "Sat", rev: 5880, occ: 95, bookings: 17 },
    { d: "Sun", rev: 3200, occ: 72, bookings: 10 },
  ];

  // ---- revenue (last 30d sparkline + monthly) ----
  const rev30 = [2840,3210,2980,3640,3510,4890,5210,4760,4980,5240,4620,5120,5480,5310,5680,5240,5880,6110,5760,6310,5990,6640,6880,5010,5460,5720,6050,5890,6320,6850];
  const monthly = [
    { m: "Jan", rev: 95200 }, { m: "Feb", rev: 102400 }, { m: "Mar", rev: 118800 },
    { m: "Apr", rev: 135100 }, { m: "May", rev: 158600 }, { m: "Jun", rev: 98650, partial: true },
  ];

  // ---- peak hours heatmap (rows = day groups, cols = hour buckets) ----
  const peakHours = [
    { label: "8–10am", v: [40, 55, 62, 70, 78, 30, 22] },
    { label: "10–12pm", v: [72, 80, 88, 84, 92, 60, 40] },
    { label: "12–2pm", v: [58, 64, 70, 66, 74, 80, 55] },
    { label: "2–4pm", v: [66, 72, 85, 78, 90, 88, 62] },
    { label: "4–6pm", v: [70, 76, 82, 80, 94, 92, 58] },
    { label: "6–8pm", v: [44, 50, 58, 54, 76, 70, 38] },
  ];
  const peakDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  const sessionMix = [
    { label: "1 hour", share: 18, n: 142 },
    { label: "3 hours", share: 34, n: 268 },
    { label: "4 hours", share: 27, n: 213 },
    { label: "6 hours", share: 13, n: 102 },
    { label: "Day pass", share: 8, n: 63 },
  ];

  // ---- pricing ----
  const pricing = {
    sessions: [
      { key: "1h", label: "1 hour", price: 199, active: true },
      { key: "3h", label: "3 hours", price: 499, active: true },
      { key: "4h", label: "4 hours", price: 599, active: true },
      { key: "6h", label: "6 hours", price: 799, active: true },
      { key: "day", label: "Day pass", price: 999, active: true },
    ],
    weekendSurcharge: 15, // %
    addons: [
      { key: "coffee", label: "Premium coffee credits", price: 120, unit: "per seat", on: true },
      { key: "meeting", label: "Private meeting room", price: 300, unit: "per hour", on: true },
      { key: "locker", label: "Secure day locker", price: 80, unit: "per day", on: true },
      { key: "monitor", label: "External monitor", price: 100, unit: "per session", on: true },
    ],
    promos: [
      { code: "EARLYBIRD20", desc: "20% off sessions before 10am", value: "20%", uses: 127, cap: 150, status: "active", ends: "15 Jul" },
      { code: "FIRSTDESK", desc: "₹150 off a guest's first booking", value: "₹150", uses: 348, cap: null, status: "active", ends: "Always on" },
      { code: "TEAMBLOCK", desc: "25% off team bookings (5+ people)", value: "25%", uses: 45, cap: 100, status: "active", ends: "30 Jun" },
      { code: "LOYALHOST", desc: "Repeat guest rewards", value: "10%", uses: 215, cap: null, status: "active", ends: "Always on" },
    ],
  };

  // ---- amenities ----
  const amenityGroups = [
    { group: "Connectivity", items: [
      { k: "wifi", label: "High-speed WiFi", on: true }, { k: "outlets", label: "Power at every seat", on: true },
      { k: "ethernet", label: "Wired ethernet", on: false }, { k: "phone", label: "Phone booth", on: true },
    ]},
    { group: "Workspace", items: [
      { k: "desk", label: "Standing desks", on: true }, { k: "monitor", label: "External monitors", on: false },
      { k: "meeting", label: "Meeting room", on: true }, { k: "printer", label: "Printer / scanner", on: true },
      { k: "locker", label: "Lockers", on: true }, { k: "whiteboard", label: "Whiteboard", on: true },
    ]},
    { group: "Comfort", items: [
      { k: "ac", label: "Air conditioning", on: true }, { k: "light", label: "Natural light", on: true },
      { k: "coffee", label: "Free coffee", on: true }, { k: "outdoor", label: "Outdoor seating", on: false },
      { k: "pet", label: "Pet friendly", on: false }, { k: "parking", label: "Parking", on: true },
    ]},
  ];

  const gallery = [
    { id: "g1", label: "Main room", src: IMG("1521017432531-fbd92d768814"), cover: true },
    { id: "g2", label: "Filter bar", src: IMG("1453614512568-c4024d13c247") },
    { id: "g3", label: "Phone booth", src: IMG("1542744173-8e7e53415bb0") },
    { id: "g4", label: "Standing desks", src: IMG("1542744094-3a31f272c490") },
    { id: "g5", label: "Meeting room", src: IMG("1497366754035-f200968a6e72") },
    { id: "g6", label: "Balcony seats", src: IMG("1559925393-8be0ec4767c8") },
  ];

  // ---- reviews ----
  const reviews = [
    { id: "r1", guest: "Aarav Menon", c: 0, stars: 5, date: "8 Jun", text: "Outstanding workspace! Booked a 4-hour block to finish a project — fast wifi, real outlets at every seat, quiet environment. The window desks are perfect for focused work.", tags: ["WiFi", "Quiet", "Comfortable"], responded: true, response: "Thank you Aarav! We love having dedicated professionals like you. Your window desk is always ready! 🎯 — Athik", booking: "CC-4M0BR" },
    { id: "r2", guest: "Sneha Reddy", c: 1, stars: 5, date: "6 Jun", text: "Excellent for back-to-back calls. The phone booth is well-soundproofed and the coffee credits are a great perk. Everything was ready when I arrived.", tags: ["Phone booth", "Coffee", "Professionalism"], responded: true, response: "Sneha, your satisfaction means everything to us! Looking forward to your next visit. 🙌 — Athik", booking: "CC-7W3FQ" },
    { id: "r3", guest: "Fatima S.", c: 4, stars: 3, date: "2 Jun", text: "Good ambiance and amazing coffee, but the wifi dropped twice during important calls. Otherwise a solid workspace. Would return if connectivity is improved.", tags: ["WiFi", "Connectivity"], responded: false, response: "", booking: "CC-6A1CD", flag: "needs-response" },
    { id: "r4", guest: "Lakshmi V.", c: 5, stars: 5, date: "4 Jun", text: "Incredible space for full-day work. Natural light, comfortable furniture, exceptional service. The team proactively offered refreshments. Best coworking space in Chennai!", tags: ["Comfort", "Service", "Ambiance"], responded: true, response: "Lakshmi, your words truly inspire us. We're honored to be your workspace of choice! ⭐ — Athik", booking: "CC-5Y9KP" },
    { id: "r5", guest: "Arjun M.", c: 3, stars: 4, date: "1 Jun", text: "Great spot for concentrated work. The standing desks are ergonomic and the environment is genuinely quiet. Recommendation: open more day-pass slots on weekends.", tags: ["Ergonomics", "Availability", "Quiet"], responded: false, response: "", booking: "CC-9Z2BN" },
    { id: "r6", guest: "Naveen K.", c: 1, stars: 5, date: "5 Jun", text: "Professional environment with excellent facilities. Standing desks, high-speed internet, and a calm workspace. This is the best place to work in Chennai.", tags: ["Standing desk", "Quiet", "Professional"], responded: true, response: "Naveen, your trust and loyalty mean a lot. See you at the next session! 💪 — Athik", booking: "CC-2T8HD" },
    { id: "r7", guest: "Priya Singh", c: 2, stars: 5, date: "7 Jun", text: "Fantastic workspace! Perfect for my startup team meetings. The meeting room is well-equipped, wifi is lightning-fast, and the entire setup is professional.", tags: ["Meeting room", "Team-friendly", "WiFi"], responded: true, response: "Priya, we're thrilled your team found what they needed. Can't wait to see your startup grow! 🚀 — Athik", booking: "CC-8T4LM" },
  ];

  const ratingBreakdown = [
    { star: 5, n: 168 }, { star: 4, n: 31 }, { star: 3, n: 9 }, { star: 2, n: 4 }, { star: 1, n: 2 },
  ];
  const ratingDims = [
    { label: "Cleanliness", v: 4.9 },
    { label: "WiFi & power", v: 4.6 },
    { label: "Noise level", v: 4.8 },
    { label: "Coffee", v: 4.9 },
    { label: "Value", v: 4.7 },
  ];

  // ---- availability (weekly hours template) ----
  const HOURS = []; for (let h = 7; h <= 21; h++) HOURS.push(h);
  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  // base open hours per day; some closed early
  const openHours = {
    Mon: [8, 20], Tue: [8, 20], Wed: [8, 20], Thu: [8, 21], Fri: [8, 21], Sat: [9, 21], Sun: [9, 18],
  };
  const blockedDates = [
    { date: "18 Jun", reason: "Private event — full buyout", kind: "event" },
    { date: "21 Jun", reason: "Deep clean & maintenance", kind: "maintenance" },
    { date: "15 Aug", reason: "Independence Day — closed", kind: "holiday" },
  ];

  const insights = [
    { icon: "trend", tone: "green", title: "⚡ Revenue growing 15% week-over-week", body: "Both locations combined earned ₹33,080 this week! Your Kadayar expansion is outperforming projections. Consider opening your 3rd location soon.", action: "View analytics" },
    { icon: "users", tone: "blue", title: "👥 Repeat guest rate is 68%", body: "Aarav, Sneha, and Naveen are your champions. They've booked 40+ times combined. Personal touches keep them coming back.", action: "Send thank you notes" },
    { icon: "star", tone: "green", title: "⭐ You're 0.1 away from 5-star rating", body: "Respond to Fatima's 3★ review about WiFi within 24h. Showing you care boosts trust. Your avg is now 4.8 across 443 reviews.", action: "Respond now" },
  ];

const fmt = (n) => "₹" + Math.round(n).toLocaleString("en-IN");
const hLabel = (h) => { const ap = h < 12 ? "am" : "pm"; const hh = h % 12 === 0 ? 12 : h % 12; return hh + ap; };

export default {
  host, locations, today, bookings, actions, notifications, week, rev30, monthly,
  peakHours, peakDays, sessionMix, pricing, amenityGroups, gallery, reviews,
  ratingBreakdown, ratingDims, HOURS, days, openHours, blockedDates, insights,
  fmt, hLabel,
};
